import { ReactElement } from 'react';

export interface Seller {
  id: string;
  document_number: string;
  company_name: string;
  trading_name: string;
  created_at: string;
  white_label: {
    id: string;
    carrier_name: string;
    favicon: string;
    logo: string;
    logo_bg: string;
    primary: string;
  };
}

export interface Role {
  id: string;
  name: string;
  seller_group_id?: string;
  access_driver_route?: boolean;
  create_delivery?: boolean;
  create_driver?: boolean;
  create_order?: boolean;
  create_report?: boolean;
  create_route?: boolean;
  read_carrier_integrations?: boolean;
  read_delivery?: boolean;
  read_dispatch_rules?: boolean;
  read_driver?: boolean;
  read_nps?: boolean;
  read_order?: boolean;
  read_order_integrations?: boolean;
  read_report?: boolean;
  read_resend_rules?: boolean;
  read_route?: boolean;
  read_sellers?: boolean;
  update_carrier_integrations?: boolean;
  update_dispatch_rules?: boolean;
  update_order_customer?: boolean;
  update_order_destination_address?: boolean;
  update_order_integrations?: boolean;
  update_order_takeout?: boolean;
  update_order_to_manual_handle?: boolean;
  update_resend_rules?: boolean;
  update_route_driver?: boolean;
  update_route_to_canceled?: boolean;
  update_sellers?: boolean;
}

export enum UserTypeEnum {
  MASTER = 'MASTER',
  ADMIN = 'ADMIN',
  USER = 'USER',
  INTERNAL = 'INTERNAL',
}

export interface User {
  id: string;
  email: string;
  active: boolean;
  type: UserTypeEnum;
  sellers: Seller[];
  role_id: string | null;
  role: Role | null;
  internal_driver_document_number?: string;
  remaining_sellers?: number;
}

export interface UserSellers {
  id: string;
  seller: Seller[];
}

export interface Sections {
  title: string;
  action: (p?: any) => void;
  icon?: ReactElement<any, any>;
  refType?: string;
}

export interface ActionsConfig {
  anchor?: Element;
  sections: Sections[];
}

export interface ActionsRef {
  open: (config: ActionsConfig) => void;
  closePopup?: () => void;
}

export interface ActionsProps {
  anchor?: Element;
  user: User;
}
